/**
 * Form event handlers for global search form found at /search.
 *
 * - Clears text input upon clear button click.
 * - Applies/removes accent color on input elements on/out of focus.
 *
 * Note: Ported directly from globally imported `clear-search.js` (Backbone.js); may have been
 * global for shared focus behavior across legacy forms.
 *
 * TODO: Remove single-context form event handlers; replace with shared/global form event handlers.
 */
class ClearSearch {
  constructor(element) {
    this.el = element;
    this.input = this.el.querySelector('[data-search-input]');
    this.inputWrapper = this.el.querySelector('[data-search-input-wrapper]');
    this.searchGlass = this.el.querySelector('[data-search-glass-icon]');

    this.el.querySelector('[data-clear-search-button]').addEventListener('click', this.clearForm.bind(this));
    this.input.addEventListener('focusin', this.applyAccentColor.bind(this));
    this.input.addEventListener('focusout', this.removeAccentColor.bind(this));

    this.removeAccentColor();
  }

  clearForm(ev) {
    ev.preventDefault();
    this.input.value = "";
    this.input.focus();
  }

  removeAccentColor() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("accent-color--border");
      this.searchGlass.classList.remove("accent-color");
    }
  }

  applyAccentColor() {
    this.inputWrapper.classList.add("accent-color--border");
    this.searchGlass.classList.add("accent-color");
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-search-results-form]');
  if (el) {
    new ClearSearch(el);
  }
});
